import React, { useEffect, useState } from 'react'
import { useIsFetching, useIsMutating } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import './TopProgressBar.css'

const TopProgressBar = () => {
  const [isVisible, setIsVisible] = useState(false)
  const [progress, setProgress] = useState(0)
  
  // Get loading states from React Query
  const isFetching = useIsFetching()
  const isMutating = useIsMutating()
  
  // Get preloader state from Redux
  const isPreloader = useSelector(state => state.Layout?.isPreloader)
  
  // Determine if we should show the progress bar
  const shouldShow = isFetching > 0 || isMutating > 0 || isPreloader
  
  useEffect(() => {
    let progressInterval
    let hideTimeout
    
    if (shouldShow) {
      setIsVisible(true)
      setProgress(0)
      
      // Simulate progress
      progressInterval = setInterval(() => {
        setProgress(prev => {
          if (prev >= 90) return prev
          return prev + Math.random() * 15
        })
      }, 200)
    } else {
      // Complete the progress bar
      setProgress(100)
      
      // Hide after animation completes
      hideTimeout = setTimeout(() => {
        setIsVisible(false)
        setProgress(0)
      }, 300)
    }
    
    return () => {
      if (progressInterval) clearInterval(progressInterval)
      if (hideTimeout) clearTimeout(hideTimeout)
    }
  }, [shouldShow])
  
  if (!isVisible) return null
  
  return (
    <div className="top-progress-bar-container">
      <div 
        className="top-progress-bar"
        style={{
          width: `${progress}%`,
          opacity: shouldShow ? 1 : 0,
        }}
      />
    </div>
  )
}

export default TopProgressBar
